export enum ProgramClassInstrumentsOrderingEnum {
  Name = 'Name',
  Type = 'Type',
}
